const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8787";

/**
 * The public site's own readiness probe.
 *
 * Deliberately not the app's API client: this is the one unauthenticated call
 * the landing page makes, and pulling in the authenticated transport (MSAL
 * token acquisition, connectivity reporting, toasts) to make it would put the
 * whole auth stack back into the public bundle.
 */
export async function checkBackendReady(signal?: AbortSignal): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/ready`, {
    headers: { Accept: "application/json" },
    signal,
  });
  if (!response.ok) {
    throw new Error(`Backend is not ready yet (HTTP ${response.status}).`);
  }
}
